import { find } from "utils/dom";
export default function () {
	const Page = find("[js-page='parceiros']");
	if (!Page) return;
	const change_modal = () =>{
		const parceiros_change = document.querySelectorAll('[data-parceiro]')
		const parceiros_itens = document.querySelectorAll('[data-parceiro-tipo]')
	
		parceiros_change.forEach(i =>{
			i.addEventListener('click', (e)=>{
				parceiros_change.forEach(i=>{i.classList.remove('active')})
				i.classList.add('active')
		
				parceiros_itens.forEach(item=>{
					if( item.dataset.parceiroTipo === i.dataset.parceiro){
						item.classList.add('parceiro-active')
					}
		
					if( item.dataset.parceiroTipo != i.dataset.parceiro){
						item.classList.remove('parceiro-active')
						item.classList.add('hidden')
					}
				})
		
			})
		})
	}
	change_modal()
	
}